var exports = {
  "kL": "container__kCe47N",
  "iW": "main__LdbQUs",
  "X8": "dismiss__HiLNES",
  "ZS": "imageContainer__cEtfO9",
  "Sl": "image__MPrbAa",
  "oA": "imageLight__V-sZVL",
  "_1": "imageDark__KonoDY",
  "DD": "title__xYG5zu",
  "h_": "description__Qgu64s",
  "lO": "cta__hC1yHN",
  "sD": "dismissAnnouncement__qsfeHb",
};

module.exports = exports;
